export default __webpack_public_path__ + "static/ellipse_circle-0c1001e07db577cc964c810c2f2fade3.png";